import type { ReactNode } from 'react';

const NBSP = ' ';

/**
 * A policy name reads as one token. Left to the layout engine, the sheet on a
 * small phone broke the sentence as "…Terms of Service and Privacy" / "Policy."
 * — the second line was a lone word with the full stop. Swapping the spaces
 * INSIDE a link's label for non-breaking ones makes each policy name wrap as a
 * unit, so the break falls between phrases ("…Terms of Service and" / "Privacy
 * Policy."); the words outside the links still wrap freely.
 *
 * Done here, not in the copy: `<Trans>` hands the anchor its label as plain
 * string children, and asking every translator to type an invisible character
 * in eight languages is how the rule would silently rot.
 */
export function keepOnOneLine(children: ReactNode): ReactNode {
  if (typeof children === 'string') return children.replace(/ /g, NBSP);
  if (Array.isArray(children)) {
    return children.map((child) =>
      typeof child === 'string' ? child.replace(/ /g, NBSP) : child,
    );
  }
  return children;
}
